const NameSpace = {
  DATA: `DATA`,
  STATES: `STATES`,
  USER: `USER`,
};

export default NameSpace;
